module.exports = __webpack_public_path__ + "img/09.fb799900.png";